import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OccDeviationService } from '../occ-deviation.service';
import { OccDeviation } from '../occ-deviation';
import { OccDeviationComponent } from '../occ-deviation/occ-deviation.component';

@Component({
    selector: 'app-occDeviation-list',
    templateUrl: './occ-deviation-list.component.html',
    styleUrls: ['./occ-deviation-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OccDeviationListComponent implements OnInit {
	constructor(
		private occDeviationService: OccDeviationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	occDeviations: OccDeviation[] = [];
	occDeviation: OccDeviation;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	 columns = [
		{ field: 'occDeviationId', header: 'ID' },
		{ field: 'lowEndExpOccPCT', header: 'Low End Occ%' },
		{ field: 'highEndExpOccPCT', header: 'High End Occ%' },
		{ field: 'occProfileName', header: 'Profile Name' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.occDeviationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-occDeviation-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.occDeviationService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.occDeviations = res.data.occDeviations;
						console.log(JSON.stringify(res.page));
						this.loading = false;
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.loading = false;
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.occDeviations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(occDeviation: OccDeviation) {
		try {
			this.formLoading = true;
			this.occDeviationService.update(occDeviation)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.occDeviations.map((occDeviation, i) => {
							if (occDeviation.occDeviationId === res.data.occDeviation.occDeviationId) {
								this.occDeviations[i] = res.data.occDeviation;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(occDeviation: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(occDeviation));

			this.formLoading = true;
			this.occDeviationService.delete(occDeviation.occDeviationId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.occDeviations.splice(this.occDeviations.indexOf(occDeviation), 1);
						this.recordTotal = this.occDeviations.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'OccDeviation ' + occDeviation.occDeviationId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'OccDeviation ' + occDeviation.occDeviationId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add OccDeviation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccDeviationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addOccDeviationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(occDeviation: OccDeviation) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			occDeviation: occDeviation,
			title: 'Edit OccDeviation'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OccDeviationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateOccDeviationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteOccDeviationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addOccDeviationCB(occDeviation: OccDeviation) {
		console.log('Adding OccDeviation: ' + JSON.stringify(occDeviation));
		// if we don't have a occDeviations array yet...
		if (!this.occDeviations) {
			this.occDeviations = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.occDeviations.unshift(occDeviation);

		// no idea what this is but it is required to update the array
		this.occDeviations = [...this.occDeviations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDeviation ' + occDeviation.occDeviationId + ' Added', life: 3000 });
	}

	updateOccDeviationCB(occDeviation: OccDeviation) {
		console.log('Updating OccDeviation: ' + JSON.stringify(occDeviation));
		let itemIndex = this.occDeviations.findIndex((item: any) => item.occDeviationId === occDeviation.occDeviationId);
		this.occDeviations[itemIndex] = occDeviation;

		// no idea what this is but it is required to update the array
		this.occDeviations = [...this.occDeviations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDeviation ' + occDeviation.occDeviationId + ' Updated', life: 3000 });
	}

	deleteOccDeviationCB(occDeviation: OccDeviation) {
		console.log('Removing OccDeviation: ' + occDeviation);
		this.occDeviations.splice(this.occDeviations.indexOf(occDeviation), 1);
		this.recordTotal = this.occDeviations.length;

		// no idea what this is but it is required to update the array
		this.occDeviations = [...this.occDeviations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OccDeviation ' + occDeviation.occDeviationId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.occDeviations ? this.first === (this.occDeviations.length - this.rows) : true; }
	isFirstPage(): boolean { return this.occDeviations ? this.first === 0 : true; }

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
